import { __read } from "tslib";
import { useCallback, useEffect, useState } from 'react';
var mediaCache = new Map();
export var useMatchMedia = function (mediaQuery) {
    var getMedia = useCallback(function () {
        var mediaQueryList = mediaCache.get(mediaQuery);
        if (mediaQueryList) {
            return mediaQueryList;
        }
        // Create new media query list for specified media query
        mediaQueryList = window.matchMedia(mediaQuery);
        mediaCache.set(mediaQuery, mediaQueryList);
        return mediaQueryList;
    }, [mediaQuery]);
    var getMatches = useCallback(function () {
        return getMedia().matches;
    }, [getMedia]);
    var _a = __read(useState(getMatches), 2), matches = _a[0], setMatches = _a[1];
    useEffect(function () {
        // Initialize or update the cache
        var media = getMedia();
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        // On update from media, update the matches
        var listener = function () {
            setMatches(media.matches);
        };
        media.addListener(listener);
        return function () {
            media.removeListener(listener);
        };
    }, [getMedia, matches]);
    return matches;
};
//# sourceMappingURL=useMatchMedia.js.map